import type {
  EditorSDK,
  RouterConfig,
} from '@wix/wix-data-client-common-standalone'
import type { ComponentRef, RouterRef } from '@wix/editor-platform-sdk-types'
import type { AppApi } from '@wix/wix-data-client-common'
import type { Schema } from '@wix/wix-data-schema-types'
import {
  runTransactionWithRetry,
  getRouterDatasetName,
} from '@wix/wix-data-client-common'

export const updateDatasetAndBindings = async (
  editorSdkProxy: EditorSDK,
  appApi: AppApi,
  {
    controllerRef,
    routerRef,
    newRouterPrefix,
    updatedRouterConfig,
    schema,
    fieldMap,
  }: {
    controllerRef: ComponentRef
    routerRef: RouterRef
    newRouterPrefix: string
    updatedRouterConfig: RouterConfig
    schema: Schema
    fieldMap: Record<string, string>
  },
) => {
  await runTransactionWithRetry(editorSdkProxy, async () => {
    await editorSdkProxy.routers.update({
      routerRef,
      prefix: newRouterPrefix,
      config: updatedRouterConfig,
    })

    await appApi.setDatasetDisplayName(
      controllerRef,
      getRouterDatasetName(schema.displayName),
      true,
    )

    await appApi.rebindComponentsToAnotherCollection({
      fieldMap,
      controllerRef,
      newCollectionId: schema.id,
    })
  })
}
